import React from "react";
import noImage from "../../assets/images/articles/no-photo.png";

const ArticleInfo = ({
  images,
  useCarousel,
  scrollByOneCard,
  canLeft,
  trackRef,
  canRight,
  article,
  navigate,
  formatPrice,
  showDashboard,
}) => {
  return (
    <div className="vaGrid">
      <div className="vaLeft">
        {images.length === 0 ? (
          <img className="vaImg" src={noImage} alt="Aucune image trouvée" />
        ) : !useCarousel ? (
          <div className="vaGallery">
            {images.map((src, idx) => (
              <div className="vaImgCard" key={idx}>
                <img className="vaImg" src={src} alt={`Annonce ${idx + 1}`} />
              </div>
            ))}
          </div>
        ) : (
          <div className="vaCarousel">
            <button
              type="button"
              className="vaCarBtn vaCarBtnLeft"
              onClick={() => scrollByOneCard(-1)}
              disabled={!canLeft}
              aria-label="Précédent"
            >
              ‹
            </button>

            <div className="vaCarouselTrack" ref={trackRef}>
              {images.map((src, idx) => (
                <div className="vaCarouselItem" key={idx}>
                  <div className="vaImgCard">
                    <img
                      className="vaImg"
                      src={src}
                      alt={`Annonce ${idx + 1}`}
                    />
                  </div>
                </div>
              ))}
            </div>

            <button
              type="button"
              className="vaCarBtn vaCarBtnRight"
              onClick={() => scrollByOneCard(1)}
              disabled={!canRight}
              aria-label="Suivant"
            >
              ›
            </button>
          </div>
        )}

        <div className="vaDetails">
          <div className="vaTitle">{article.titre}</div>
          {article?.prix && article.prix > 0 ? (
            <div className="vaPrice">{formatPrice(article.prix)} MGA</div>
          ) : null}
          <div className="vaCity">
            {article.ville} {article.quartier ? `• ${article.quartier}` : ""}
          </div>
          <div className="vaDate">
            {article.createdAt
              ? new Date(article.createdAt).toLocaleString("fr-FR")
              : ""}
          </div>
        </div>

        {/* Localisation + Signalement */}
        {article.ville && (
          <div style={{ marginTop: 14 }}>
            <div className="daInfoTitle">Localisation</div>
            <div
              style={{
                fontSize: 14,
                color: "var(--couleur-secondaire)",
                lineHeight: 1.5,
                textTransform: "uppercase",
              }}
            >
              {article.ville}
            </div>
          </div>
        )}
      </div>

      <div className="vaRight">
        {/* description */}
        <div className="vaCard">
          <div className="daInfoTitle">Description</div>

          <div className="content_description">
            {article.description
              ? article.description.split(/\r?\n/).map((line, index) => (
                  <div
                    className="texte_description"
                    key={index}
                    style={{ marginLeft: "0 !important" }}
                  >
                    {line}
                    <br />
                  </div>
                ))
              : "Aucune description disponible"}
          </div>
        </div>
        <div className="vaCard d-none">
          <div className="vaCardTitle">Les informations clés</div>

          <div className="vaInfoList">
            {(article.infoCle || []).length === 0 ? (
              <div style={{ fontSize: 12, opacity: 0.75 }}>
                Aucune information clé.
              </div>
            ) : (
              (article.infoCle || []).map((it, idx) => (
                <div className="vaInfoRow" key={`${it.name}-${idx}`}>
                  <div className="info_icon_bootstrap">
                    <i className={`bi bi-${it.icon}`}></i>
                    <div className="vaInfoKey">{it.name}</div>
                  </div>
                  <div className="vaInfoVal">{it.value || "-"}</div>
                </div>
              ))
            )}
          </div>
        </div>

        <button className="vaBtn" type="button" onClick={() => showDashboard()}>
          DASHBOARD
        </button>
      </div>
    </div>
  );
};
export default ArticleInfo;
